import { render, staticRenderFns } from "./CreateWeightedScorePage.vue?vue&type=template&id=02ced4d2"
import script from "./CreateWeightedScorePage.vue?vue&type=script&lang=ts"
export * from "./CreateWeightedScorePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports